/* eslint-disable no-nested-ternary */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-state */
import TextField from "@material-ui/core/TextField";
import React from "react";
// import "../contractStyle.css";
import DateFnsUtils from "@date-io/date-fns";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { styled } from "@material-ui/core";

const CustomRadio = styled(Radio)({
  "&.Mui-checked": {
    color: "#f57c00 !important",

  },
});

const CustomFormControlLabel = styled(FormControlLabel)({
  "& span": {
    fontSize: "16px !important",
    fontWeight: "bold !important",
  },
  padding: "0 10px",

});

function TextFieldComponent(props) {
  return (
    <TextField
      {...props}
      inputProps={{
        readOnly: Boolean(true),
      }}
    />
  );
}
export class SettlementForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: new Date(),
    };
  }

  componentDidMount() {}

  getSettleAmount = (values) => {
    let result;
    if (!Number.isNaN(Math.abs(values.settleAmount)) && values.settleAmount !== "") {
      if (Math.abs(values.settleAmount) !== 0) {
        if (values.paymentType.toLowerCase() === "paid") {
          result = Math.abs(values.settleAmount);
        } else if (values.settleAmount <= 0) {
          result = values.settleAmount;
        } else {
          result = -values.settleAmount;
        }
      } else {
        result = 0;
      }
    } else {
      result = null;
    }
    return result;
  };

  allowAlphaNumeric(event, value) {
    const re = /^[0-9a-zA-Z]*$/;

    if (!re.test(value)) {
      event.preventDefault();
    }
  }

  preventAlphaCharacter(event, value) {
    const re = /^-?[ 0-9.]*$/;

    if (!re.test(value)) {
      event.preventDefault();
    }
  }

  render() {
    const { values, handleChange } = this.props;

    return (
      <form className="form-horizontal">
        <div className="contractDetailsWrapper">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container spacing={2}>
              <Grid item xs={12} className="selectWrapper">
                <FormControl className="settlementFieldWrapper">
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue={values.paymentType}
                  >
                    <CustomFormControlLabel onChange={handleChange("paymentType", "event")} value="Paid" label="Paid" control={<CustomRadio />} />
                    <CustomFormControlLabel onChange={handleChange("paymentType", "event")} value="Received" label="Recieved" control={<CustomRadio />} />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={2} justifyContent="space-between">
              <Grid item xs={6} sm={4}>
                <FormControl className="settlementFieldWrapper">
                  <TextField
                    id="settleAmount"
                    onKeyPress={(value) => {
                      this.preventAlphaCharacter(value, value.key);
                    }}
                    onPaste={(value) => {
                      this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData("Text"));
                    }}
                    value={this.getSettleAmount(values)}
                    label="Settlement Amount"
                    onChange={handleChange("settleAmount", "event")}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={4}>
                <FormControl className="settlementFieldWrapper">
                  <TextField
                    id="transactionId"
                    onKeyPress={(value) => {
                      this.allowAlphaNumeric(value, value.key);
                    }}
                    onPaste={(value) => {
                      this.allowAlphaNumeric(value, value.nativeEvent.clipboardData.getData("Text"));
                    }}
                    value={values.transactionId}
                    label="Transaction ID"
                    onChange={handleChange("transactionId", "event")}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={4} className="settlementDateWrapper">
                <DatePicker
                  // required
                  autoOk
                  animateYearScrolling
                  maxDate={new Date()}
                  disableToolbar
                  format="MM/dd/yyyy"
                  margin="normal"
                  id="settlementDate"
                  label="Select Date"
                  value={values.date}
                  onChange={handleChange("date", "value")}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  TextFieldComponent={TextFieldComponent}
                />
              </Grid>
            </Grid>
          </MuiPickersUtilsProvider>
        </div>
      </form>
    );
  }
}
